import styled from "styled-components";

const BreadCrumbs = styled.div`
  font-size: 10pt;
  color: blue;
  margin-bottom: 1rem;
`;

export default BreadCrumbs;
